import { render, staticRenderFns } from "./FirmaAutorizacionComponent.vue?vue&type=template&id=58969a10"
import script from "./FirmaAutorizacionComponent.vue?vue&type=script&lang=js"
export * from "./FirmaAutorizacionComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports